import { FC, useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { PlanTag } from '@/shared';
import { PlatformAlert } from '@/shared/components/alerts';

interface EmployeeHeadcountProps {
    filters: any;
    handleChange: any;
}

const EmployeeHeadcount: FC<EmployeeHeadcountProps> = ({ filters, handleChange }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { hasMinimumPlan } = useEntitlements();

    const { token } = useAntDesignTheme();

    const employeeRangesValues = [
        '1 - 10',
        '11 - 50',
        '51 - 250',
        '251 - 1k',
        '1k - 5k',
        '5k - 10k',
        '10k - 50k',
        '50k - 100k',
        '100k+',
    ];

    return !hasMinimumPlan('plus') ? (
        <div style={{ textAlign: 'center', margin: '2rem' }}>
            <PlanTag plan={'plus'} style={{ marginLeft: '0.5rem' }} />
        </div>
    ) : (
        <>
            <PlatformAlert
                title='Headcount coverage'
                showIcon
                status='info'
                icon={
                    <TbInfoCircle
                        size='1.125rem'
                        style={{
                            marginRight: '0.75rem',
                            marginTop: '0.1rem',
                        }}
                    />
                }
                description={
                    <span>
                        Search results that fall within a selected range may include subsidiary headcount without
                        explicitly mentioning it.
                    </span>
                }
                style={{ marginBottom: '0.75rem' }}
            />
            <div style={{ marginBottom: '0.5rem' }}>
                <small style={{ color: token.colorTextTertiary }}>Headcount Ranges</small>
            </div>
            <Checkbox.Group
                value={filters?.employeeHeadcount}
                onChange={(checkedValues) => {
                    handleChange(['employeeHeadcount'], checkedValues);
                }}
            >
                {employeeRangesValues?.map((er: any) => {
                    return (
                        <div key={er} style={{ width: '100%' }}>
                            <Checkbox value={er}>{er}</Checkbox>
                        </div>
                    );
                })}
            </Checkbox.Group>
            {/* <Divider style={{ marginTop: '1rem' }} />
                        <Form.Item
                            style={{ marginBottom: 0 }}
                            label={<small style={{ color: token.colorTextTertiary }}>Custom Range</small>}
                        >
                            <Row>
                                <Col span={10}>
                                    <InputNumber style={{ width: '100%' }} />
                                </Col>
                                <Col span={4} style={{ textAlign: 'center' }}>
                                    <TbArrowRight
                                        size="1.25rem"
                                        style={{ verticalAlign: '-0.625rem', color: token.colorTextTertiary }}
                                    />
                                </Col>
                                <Col span={10}>
                                    <InputNumber style={{ width: '100%' }} />
                                </Col>
                            </Row>
                        </Form.Item> */}
        </>
    );
};

export default EmployeeHeadcount;
